module.exports = __webpack_public_path__ + "static/media/iStock@2x.8677c720.png";